import { render, staticRenderFns } from "./BusyConfig.vue?vue&type=template&id=fbba2e66&scoped=true&"
import script from "./BusyConfig.vue?vue&type=script&lang=js&"
export * from "./BusyConfig.vue?vue&type=script&lang=js&"
import style0 from "./BusyConfig.vue?vue&type=style&index=0&id=fbba2e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbba2e66",
  null
  
)

export default component.exports